import {PendingPtaValueObject} from './PendingPtaValueObject.js'
import UserProfileNotificationsValueObject from './UserProfileNotificationsValueObject.js'

export default class NotificationsValueObjectFactory {
  static pendingPtaValueObject = ({pendingPta}) => new PendingPtaValueObject({pendingPta})

  static userProfileNotificationsValueObject = ({isPortalAnnoucementsShowed}) => {
    return new UserProfileNotificationsValueObject({isPortalAnnoucementsShowed})
  }
}
